import { Box, Grid } from "@mui/material"
import MenuTab from "../../../component/tabs/MenuTab"
import MezzoForm from "../../structure/Cantine/MezzoForm"
import { useSelector } from "react-redux";
const SubMezziLogistica = ({ Component }) => {
    const singleData = useSelector((state) => state.mezzi?.singleMezzi[0]);
    return (
        <>
            <div className="pageTemplate">
                <Grid container spacing={3}>
                    <Grid  size={{lg:3, md:4, xs:12 }} sx={{ mt: "20px" }}>
                        <MezzoForm singleData={singleData}/>
                    </Grid>
                    <Grid  size={{lg:9, md:8, xs:12}}>
                        <Box className="TemplateForm__right">
                            <MenuTab subMezziLogistica={true} />
                        </Box>
                        {Component && <Component />}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default SubMezziLogistica